<template>
    <div>
        <Title
            class="hidden md:block md:mt-4 md:mb-4"
            style-code-page
            :text="$route.meta.pageTitle"
        />
        <div class="md:white-box md:rounded-t-lg md:px-8 md:py-5">
            <transition
                name="opacity"
                mode="out-in"
            >
                <Skeletons v-if="isLoadingData" />
                <div v-else>
                    <ul
                        v-if="needRefund && needSupplement"
                        class="text-tip pb-2.5 border-b border-gray-200 md:border-0 mb-0"
                    >
                        <li>同時申請部分投資終止及補費變更項目時，同一次交易補退費將合併計算。</li>
                    </ul>
                    <div class="divide-y divide-gray-200 md:divide-y-0">
                        <div v-if="needRefund">
                            <h4 class="py-2.5 md:pt-0 md:pb-4">
                                欲退費之匯款帳號
                            </h4>
                            <div
                                v-if="refundBankList"
                                class="md:grid md:grid-cols-2 md:gap-4 mb-2.5 md:mb-4"
                            >
                                <CardPayment
                                    v-for="refundBank in refundBankList"
                                    :key="refundBank.bankAccount"
                                    :is-active="bankAccount === refundBank.bankAccount"
                                >
                                    <template #input>
                                        <Radio
                                            v-model:checked-value="bankAccount"
                                            :value="refundBank.bankAccount"
                                            :text="refundBank.bankName"
                                            :text-class="'text-gray-900'"
                                            name="bankAccount"
                                        />
                                    </template>
                                    <template #content>
                                        <div class="flex">
                                            <div class="w-3/4 pl-5 pr-2.5">
                                                <span class="h6 text-gray-400">匯款帳號</span>
                                                <p class="h4 text-gray-700 break-all">
                                                    {{ refundBank.bankAccount }}
                                                </p>
                                            </div>
                                            <div class="w-1/4">
                                                <span class="h6 text-gray-400">帳號幣別</span>
                                                <p class="h4 text-gray-700">
                                                    {{ refundBank.currencyText }}
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                </CardPayment>
                            </div>
                        </div>
                        <div v-if="needSupplement">
                            <h4 class="py-2.5 md:pt-0 md:pb-4">
                                欲補費方式
                            </h4>
                            <div class="md:grid md:grid-cols-2 md:gap-4 md:mb-2.5">
                                <CardPayment
                                    v-if="supplement.creditCard"
                                    :is-active="payKind === '3'"
                                >
                                    <template #input>
                                        <Radio
                                            v-model:checked-value="payKind"
                                            :text-class="'text-gray-900'"
                                            value="3"
                                            text="信用卡繳費"
                                            name="payKind"
                                        />
                                    </template>
                                    <template #content>
                                        <div class="text-gray-700 pl-5 mb-2.5">
                                            {{ supplement.credBank }}
                                        </div>
                                        <div class="flex">
                                            <div class="w-3/4 pl-5 pr-2.5">
                                                <span class="h6 text-gray-400">信用卡卡號</span>
                                                <p class="h4 text-gray-700 break-all">
                                                    {{ supplement.creditCardNo }}
                                                </p>
                                            </div>
                                            <div class="w-1/4">
                                                <span class="h6 text-gray-400">有效年月</span>
                                                <p class="h4 text-gray-700">
                                                    {{ supplement.expdateYY }}/{{ supplement.expdateMM }}
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                </CardPayment>
                                <CardPayment
                                    v-if="supplement.transfer"
                                    :is-active="payKind === '4'"
                                >
                                    <template #input>
                                        <Radio
                                            v-model:checked-value="payKind"
                                            :text-class="'text-gray-900'"
                                            value="4"
                                            text="金融機構轉帳"
                                            name="payKind"
                                        />
                                    </template>
                                    <template #content>
                                        <div class="pl-5">
                                            <div class="text-gray-700 mb-2.5">
                                                {{ supplement.bank }}
                                            </div>
                                            <div>
                                                <span class="h6 text-gray-400">匯款帳號</span>
                                                <p class="h4 text-gray-700 break-all">
                                                    {{ supplement.acctNo }}
                                                </p>
                                            </div>
                                        </div>
                                    </template>
                                </CardPayment>
                                <CardPayment :is-active="payKind === '5'">
                                    <template #input>
                                        <Radio
                                            v-model:checked-value="payKind"
                                            :text-class="'text-gray-900'"
                                            value="5"
                                            text="自行繳費"
                                            name="payKind"
                                        />
                                    </template>
                                    <template #content>
                                        <div class="pl-5">
                                            <div class="text-gray-700 mb-2.5">
                                            </div>
                                            <ol class="list-decimal text-base pr-2">
                                                <li class="ml-5">
                                                    可利用以下管道進行繳費：便利商店繳費、臨櫃繳款、ATM繳款、網路繳款。
                                                </li>
                                                <li class="ml-5">
                                                    繳款通知單請待繳款金額通知後，依簡訊/Email通知自行上網列印。
                                                </li>
                                                <li class="ml-5">
                                                    列印繳款單建議使用雷射印表機，以避免條碼無法判讀。
                                                </li>
                                            </ol>
                                        </div>
                                    </template>
                                </CardPayment>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
    <Bottombar>
        <template #right>
            <button
                class="btn btn-accent rounded-full"
                :disabled="isDisable"
                @click="goNext"
            >
                下一步
            </button>
        </template>
    </Bottombar>
    <Loading :is-loading="isLoading" />
</template>

<script>
import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { getInfoPayment, submitPayment } from '@/apis/payment.js';
import routeName from '@/router/constant.js';
import Bottombar from '@/components/layout/Bottombar.vue';
import Title from '@/components/text/Title.vue';
import CardPayment from './CardPayment.vue';
import Radio from '@/components/radios/Radio.vue';
import Loading from '@/components/Loading.vue';
import Skeletons from './Skeletons.vue';

export default {
    name: 'RefundPayment',
    components: {
        Bottombar,
        Title,
        CardPayment,
        Radio,
        Loading,
        Skeletons
    },
    setup() {
        const bankAccount = ref('');
        const payKind = ref('');
        const isLoadingData = ref(false);
        const isLoading = ref(false);
        const router = useRouter();
        const refundBankList = ref([]);
        const needRefund = ref(false);
        const needSupplement = ref(false);
        const supplement = ref({});

        const getData = () => {
            isLoadingData.value = true;
            getInfoPayment().then(res => {
                if (res.data) {
                    if (res.data.refund?.refundBankList) refundBankList.value = res.data.refund.refundBankList;
                    supplement.value = res.data.supplement;
                    needRefund.value = res.data.needRefund;
                    needSupplement.value = res.data.needSupplement;
                }
            }).finally(() => {
                isLoadingData.value = false;
            });
        };
        getData();

        const isDisable = computed(() => {
            let disable = true;
            if (needRefund.value && needSupplement.value) {
                if (bankAccount.value.length && payKind.value.length) disable = false;
            } else {
                if (bankAccount.value.length || payKind.value.length) disable = false;
            }
            return disable;
        });

        const goNext = () => {
            isLoading.value = true;
            const returnData = {};
            returnData.refund = needRefund.value ? { bankAccount: bankAccount.value } : null;
            returnData.supplement = needSupplement.value ? { payKind: payKind.value } : null;
            submitPayment(returnData).then(res => {
                router.push({ name: routeName.OTP });
            }).finally(() => {
                isLoading.value = false;
            });
        };
        return {
            needRefund,
            needSupplement,
            bankAccount,
            payKind,
            refundBankList,
            supplement,
            isDisable,
            isLoadingData,
            isLoading,
            goNext
        };
    },
};
</script>

<style lang="scss" scoped>
:deep(label) {
    align-items: start !important;
    input[type="checkbox"] {
        @apply mt-[0.3125rem] xs:mt-1.5;
    }
    input.formed-radio {
        @apply mt-[0.3125rem] xs:mt-1.5;
    }
}
</style>
